import SwiperCore, {Pagination, Navigation} from "swiper";
import {PaginationOptions} from "swiper/types";
import {SlideProps} from "@FRAMEWORK/ui/types/d";
import {GuideSlider} from "@COMPONENTS/style/slide";
import {ReactNode, forwardRef} from "react";

interface Props extends SlideProps {
	children: ReactNode;
	perView?: number;
	spaceBetween?: number;
}

const GuideSlide = forwardRef<SwiperCore, Props>(({children, perView, spaceBetween}: Props, ref) => {
	const PaginationParams: PaginationOptions = {
		type: "fraction",
		formatFractionCurrent(number) {
			if (number < 10) {
				return `0${number}`;
			} else {
				return number;
			}
		},
		formatFractionTotal(number) {
			if (number < 10) {
				return `0${number}`;
			} else {
				return number;
			}
		},
	};
	return (
		<GuideSlider
			onBeforeInit={swiper => {
				if (ref !== null) {
					(ref as {current: SwiperCore}).current = swiper;
				}
			}}
			loop={true}
			slidesPerView={perView}
			spaceBetween={spaceBetween}
			pagination={PaginationParams}
			navigation={true}
			modules={[Pagination, Navigation]}
		>
			{children}
		</GuideSlider>
	);
});

export default GuideSlide;
